










































































	// @ts-ignore
    import _ from './ProcedureDomainIndex.ts'; export default _;
